export default "__VITE_ASSET__6MNT7e1J__"